import React, { memo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import ActionButton from 'components/shared/ActionButton/ActionButton';
import ActionTwoHopPopUpModal from '../ActionTwoHopPopUpModal/ActionTwoHopPopUpModal';
import LoadingIndicator from 'components/shared/LoadingIndicator/LoadingIndicator';
import CommissionErrorBox from 'components/features/Commissioning/CommissionErrorBox/CommissionErrorBox';
import { doCancelTwoHopAlignment } from 'redux/actions';
import { Status } from 'common/utils/constants';
import { getErrorMessage, isObjectEmpty } from 'common/utils/helpers';
import '../ActionTwoHopProgressViewModal.css';

const ActionTwoHopModalFooterContainer = ({ action, onCloseScreen, actionsPageThis }) => {
  const dispatch = useDispatch();
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [isInProgressModalOpen, setIsInProgressModalOpen] = useState(false);
  const [cancelTwoHopError, setCancelTwoHopError] = useState(null);
  const twoHopCancelStatus = useSelector(
    (store) => store.ui.actionsPage.twoHopCancelStatusDictionary?.[action?.commissioningId]
  );
  const twoHopStatusInstanceDictionary = useSelector(
    (store) => store.ui.actionsPage?.twoHopStatusInstanceDictionary?.[action?.commissioningId] ?? {}
  );

  const setCancelTwoHopAlignmentStatusName = `POST-CancelTwoHopAlignment-${action?.commissioningId}-set`;
  const setCancelTwoHopAlignmentStatus = useSelector((store) => store.statuses?.[setCancelTwoHopAlignmentStatusName]);

  const isCancelCompleted = twoHopCancelStatus?.entityState?.status === 'completed';

  const confirmPopUpContent = (
    <>
      <strong>WARNING</strong>: Please confirm that Two-Hop will be cancelled and only completed Heatmaps will be saved.
      Two-Hop will complete the Dither/Raster in progress which may take 3 minutes.
    </>
  );

  const inProgressPopUpTitle = isCancelCompleted ? (
    'Cancelled Alignment Progress Successfully'
  ) : (
    <LoadingIndicator text={'Cancelling Two-Hop Alignment Progress'} />
  );

  const inProgressPopUpContent = (
    <>
      {isCancelCompleted ? 'CANCEL is completed.' : 'CANCEL will complete in 3 minutes.'} See{' '}
      <Link
        id="ActionTwoHopProgressViewModal_Bottom_Action_Btn"
        className="ActionTwoHopProgressViewModal_Bottom_Action_Btn"
        to={'/console/actions'}
        onClick={() => {
          onCloseScreen();
          actionsPageThis && actionsPageThis.setState({ refreshActionList: true });
        }}
      >
        Actions
      </Link>{' '}
      page for details.
    </>
  );

  const handleCancelTwoHopAlignment = () => {
    const cb_success = () => {
      dispatch(doCancelTwoHopAlignment('get', action?.commissioningId));
      setIsConfirmModalOpen(false);
      setIsInProgressModalOpen(true);
    };
    const cb_failed = (error) => {
      setCancelTwoHopError(error.message);
      setIsConfirmModalOpen(false);
    };
    dispatch(doCancelTwoHopAlignment('set', action?.commissioningId, cb_success, cb_failed));
  };

  const disableCancelBtn = () =>
    twoHopCancelStatus?.entityExists === true ||
    action?.runtimeStatus === 'Completed' ||
    action?.runtimeStatus === 'Error' ||
    isObjectEmpty(twoHopStatusInstanceDictionary);

  return (
    <div
      id="ActionTwoHopModalFooterContainer_Bottom_Container"
      className="ActionTwoHopProgressViewModal_Bottom_Container"
    >
      {cancelTwoHopError != null && (
        <CommissionErrorBox
          title={`Cancel Alignment Progress Error: ${cancelTwoHopError}`}
          message={getErrorMessage(cancelTwoHopError)}
          onClose={() => setCancelTwoHopError(null)}
        />
      )}
      {isConfirmModalOpen && (
        <ActionTwoHopPopUpModal
          modalWidth={454}
          modalHeight={249}
          title={'Cancel Two-Hop Alignment Progress?'}
          content={confirmPopUpContent}
          onClose={() => setIsConfirmModalOpen(false)}
          onConfirm={() => {
            handleCancelTwoHopAlignment();
          }}
        />
      )}
      {isInProgressModalOpen && (
        <ActionTwoHopPopUpModal
          modalWidth={454}
          modalHeight={207}
          title={inProgressPopUpTitle}
          content={inProgressPopUpContent}
          onClose={() => {
            setIsInProgressModalOpen(false);
          }}
        />
      )}
      <div id="ActionTwoHopProgressViewModal_Bottom_Left" className="ActionTwoHopProgressViewModal_Bottom_Left">
        <div id="ActionTwoHopProgressViewModal_Bottom_Message" className="ActionTwoHopProgressViewModal_Bottom_Message">
          To continue on Commissioning these Pivot systems, please go to{' '}
          <Link
            id="ActionTwoHopProgressViewModal_Bottom_Action_Btn"
            className="ActionTwoHopProgressViewModal_Bottom_Action_Btn"
            to={'/console/actions'}
            onClick={() => {
              onCloseScreen();
              actionsPageThis && actionsPageThis.setState({ refreshActionList: true });
            }}
          >
            Actions
          </Link>{' '}
          page and start commissioning Pivot 1 system.
        </div>
      </div>
      <div id="ActionTwoHopProgressViewModal_Bottom_Right" className="ActionTwoHopProgressViewModal_Bottom_Right">
        <ActionButton
          title={'Cancel Alignment Progress'}
          disabled={disableCancelBtn()}
          loading={setCancelTwoHopAlignmentStatus === Status.PENDING}
          onClick={() => setIsConfirmModalOpen(true)}
          customStyles={{
            height: '100%',
            font: "400 14px 'Rubik'",
            border: '1px solid var(--bermudaBlue-3)'
          }}
          backgroundColor={'var(--bermudaBlue-6)'}
          textColor={'var(--bermudaBlue)'}
          hoveredBackgroundColor={'var(--bermudaBlue-7'}
        />
      </div>
    </div>
  );
};

export default memo(ActionTwoHopModalFooterContainer);
